import { render } from "./DemoN.vue?vue&type=template&id=407816fe"
import script from "./DemoN.vue?vue&type=script&lang=js"
export * from "./DemoN.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pixsmart_site_v2\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__